import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client';

import { GetUploadCredentials } from '../../athena/types/GetUploadCredentials';

export const GET_UPLOAD_CREDENTIALS = gql`
  mutation GetUploadCredentials {
    cabinet {
      getUploadCredentials {
        awsCredential {
          accessKeyId
          expiration
          secretAccessKey
          sessionToken
        }
        baseUrl
        bucket
        pathPrefix
      }
    }
  }
`;

export const useGetUploadCredentials = () =>
  useMutation<GetUploadCredentials>(GET_UPLOAD_CREDENTIALS);
